import { orEmpty } from '@ps/utils';

import { Survey } from '../../models';
import { SurveyUrlsForm } from '../types/survey-urls-form.types';

export class SurveyUrlsFormMapper {
  public fromSurvey(survey: Survey): SurveyUrlsForm {
    return {
      sameSettingsForAllSurveys: false,
      liveUrl: orEmpty(survey.liveUrl),
      testUrl: orEmpty(survey.testUrl),
      disableAutomaticVariableMapping: !!survey.urlTransform,
    };
  }
}
